module.exports = __webpack_public_path__ + "img/month_2_icon.c7653954.png";